export const GENERAL = {
    "oauthClientId": "bc5e2cc965c883d4319f391a8c3036000c8ad419d908c77ad1503ae02fcf31f6",
    "oauthClientSecret": "2ea854d975a1673015c0d0be91806f8a6d9d5b859740df7709aaeb54a59ea9f5",
    "monsidoPath": "https://login.monsido.com/",
    "sudoRedirectUri": "",
    "version": "2.2.7"
}